import { render, staticRenderFns } from "./branch-plan.vue?vue&type=template&id=4a148478"
import script from "./branch-plan.vue?vue&type=script&lang=js"
export * from "./branch-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports